import firebaseApp from "../../firebase/credenciales";
import { getFirestore, deleteDoc, collection, doc } from "firebase/firestore";
const db = getFirestore(firebaseApp);

export default async function eliminarProductoHome(producto, pagina, usuario) {
  const coleccionRef = collection(db, "Cultivo_en_proceso/"+pagina+"/Productos/");
  const docuRef = doc(coleccionRef, producto.fecha2);
  const eliminado = await deleteDoc(docuRef);

  return eliminado;
}
